import { debounce } from '@repo/utils';
import { EditorState } from 'lexical';
import { TextEditorHandler } from '../handlers/textEditorHandler';

const textEditorHandler = TextEditorHandler.instance;

export const debouncedOnChangeHandler = debounce(
  (
    editorState: EditorState,
    editorStateLocalStorageKey: string,
    setLastSavedAt: React.Dispatch<React.SetStateAction<Date | null>>,
    isEmpty?: boolean,
    onAutoSave?: () => void,
  ) => {
    if (isEmpty) {
      textEditorHandler.deleteEditorStateFromLocalStorage(
        editorStateLocalStorageKey,
      );
    } else {
      textEditorHandler.setEditorStateInLocalStorage(
        editorStateLocalStorageKey,
        editorState,
      );
    }
    setLastSavedAt(new Date());
    onAutoSave?.();
  },
  1000,
);
